<script lang="ts" setup>
import { computed } from 'vue';
import FieldChoice from './FieldChoice.vue';
import FieldCondition from './FieldCondition.vue';
import { Option } from '@/helpers/Interfaces';
import { DetailsBuilderContract } from '@/components/builder/details';
import { VisibleBlueprint } from '@/components/builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';

defineOptions({
    name: 'field-visible',
    components: {
        'field-choice': FieldChoice,
        'field-condition': FieldCondition
    }
});

const props = defineProps({
  "blueprint": null,
  "details": null,
  "label": { default: null }
});
const blueprint = computed(() => props.blueprint);

const visibleOptions: Option<AlwaysChoice | WhenChoice>[] = [
    { value: AlwaysChoice.Always, text: '[[[Zawsze]]]' },
    { value: WhenChoice.When, text: '[[[Warunkowo]]]' }
];
</script>

<template>
    <div>
        <field-choice v-model="blueprint.visible" :options="visibleOptions" :label="label || $t('[[[Widoczność]]]')" />
        <field-condition v-model="blueprint.visibleWhen" :label="label" :show-label="false" :details="details" :when="blueprint.visible" />
    </div>
</template>
